"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_EVENT_QUEUE_SIZE = exports.NULL_SENTINEL = exports.SESSION_ASSIGNMENT_CONFIG_LOADED = exports.BASE_URL = exports.DEFAULT_POLL_CONFIG_REQUEST_RETRIES = exports.DEFAULT_INITIAL_CONFIG_REQUEST_RETRIES = exports.POLL_JITTER_PCT = exports.POLL_INTERVAL_MS = exports.REQUEST_TIMEOUT_MILLIS = exports.DEFAULT_REQUEST_TIMEOUT_MS = void 0;
exports.DEFAULT_REQUEST_TIMEOUT_MS = 5000;
exports.REQUEST_TIMEOUT_MILLIS = exports.DEFAULT_REQUEST_TIMEOUT_MS; // for backwards compatibility
exports.POLL_INTERVAL_MS = 30000;
exports.POLL_JITTER_PCT = 0.1;
exports.DEFAULT_INITIAL_CONFIG_REQUEST_RETRIES = 1;
exports.DEFAULT_POLL_CONFIG_REQUEST_RETRIES = 7;
exports.BASE_URL = 'https://fscdn.eppo.cloud/api';
exports.SESSION_ASSIGNMENT_CONFIG_LOADED = 'eppo-session-assignment-config-loaded';
exports.NULL_SENTINEL = 'EPPO_NULL';
// number of logging events that may be queued while waiting for initialization
exports.MAX_EVENT_QUEUE_SIZE = 100;
//# sourceMappingURL=constants.js.map